import { render, staticRenderFns } from "./FixedMovementDataRow.vue?vue&type=template&id=610886ca&scoped=true&"
import script from "./FixedMovementDataRow.vue?vue&type=script&lang=ts&"
export * from "./FixedMovementDataRow.vue?vue&type=script&lang=ts&"
import style0 from "./FixedMovementDataRow.vue?vue&type=style&index=0&id=610886ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610886ca",
  null
  
)

export default component.exports